import footerbg from "../assets/imgs/footer-bg.png";

const Footer = () => {
  return (
    <>
      <div>
        <img src={footerbg} alt="Footer Background" />
      </div>
      <div className="w-full text-center py-4 bg-white">
        <small className="text-base text-[var(--dark-blue)] font-extrabold">© Copyright 2024. All rights reserved.</small>
      </div>
    </>
  );
};

export default Footer;
